import JsonP from 'jsonp'
export default class Axios {
    static jsonp(options) {
        return new Promise((resolve, reject) => {
            JsonP(`https://tp.dahe.cn${options.url}`, {
                param: 'callBack'
            }, function (err, res) {
                resolve(JSON.parse(res))
                // if (res.status === 'success') {
                //     resolve(res)
                // } else {
                //     reject(err)
                // }
            })
        })
    }
}
